module.exports = __webpack_public_path__ + "images/choose_file2.png";